import React from "react"
import Helmet from "react-helmet"
export default function MetaData() {
  return (
    <div>
      <Helmet>
        <title>Debajit Deb - Personal Website</title>
        <meta
          name="description"
          content="Welcome to Debajit's Personal Website ❤️"
        ></meta>
        <meta charset="UTF-8"></meta>
      </Helmet>
    </div>
  )
}
